import React from "react";
import { AppList } from "components/list/AppList";
import { Datagrid, TextField, EditButton, DeleteButton } from 'react-admin';

import { ScrollingWrapper } from '../../../components/ScrollingWrapper';
import { DatagridWithBlockProps } from '../../../components/_helpers/props/DatagridProps';

import { ArticleTemplatesFilter } from './ListFilters';


const defaultSort = { field: 'template', order: 'DESC' };


export const ArticleTemplatesList = props => {
	return (
		<AppList
			{...props}
			sort={defaultSort}
			exporter={false}
			bulkActionButtons={false}
			// filters={<ArticleTemplatesFilter />}
		>
			<ScrollingWrapper>
				<Datagrid {...DatagridWithBlockProps} >
					<TextField source="template" sortable={true} />
					<TextField source="load_time" />
					<TextField source="load_time_kilo" />
					<TextField source="load_time_pallet" />
					<EditButton label="" />
					<DeleteButton label="" />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
}
